<template>
  <div class="Card">
    <div class="Title">
      <h2>{{ title }}</h2>
    </div>
    <div class="Content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      required: true,
      default: 'title',
    },
  },
};
</script>

<style lang="scss">
.Card {
  @include basicCard();
}
</style>
